import { SetStateAction, Dispatch } from 'react'
import { Button, Grid } from '@mui/material'

import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

import { useStyles } from './styles'

interface IImpactsLibraryPaginationProps {
  page: number
  totalPages: number
  setPage: Dispatch<SetStateAction<number>>
}

const ImpactsLibraryPagination = ({
  page,
  totalPages,
  setPage,
}: IImpactsLibraryPaginationProps) => {
  const classes = useStyles()

  const handleNextClick = () => {
    if (page === totalPages) return

    setPage((prevPage) => prevPage + 1)
  }
  const handlePrevClick = () => {
    if (page === 0) return

    setPage((prevPage) => prevPage - 1)
  }

  return (
    <Grid className={classes.paginationButtonWrapper}>
      <Button
        className={classes.paginationButton}
        variant="contained"
        disabled={page === 0}
        onClick={handlePrevClick}
      >
        <ChevronLeftIcon />
      </Button>
      <Button
        className={classes.paginationButton}
        variant="contained"
        disabled={page === totalPages}
        onClick={handleNextClick}
      >
        <ChevronRightIcon />
      </Button>
    </Grid>
  )
}

export { ImpactsLibraryPagination }
